/** @format */

import React, { useEffect, useState } from "react";
import { Badge, Menu, MenuItemProps } from "antd";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { Routes } from "../../../utils/Routes";
import { usePermissionForRoute } from "../../../utils/permissions/routeToPermissionMap";
import { selectorLoggedUser } from "../../../redux-modules/selectors/selectorsAuth";
import { isAdminOrRoot } from "../../../utils/permissions/isAdminOrRoot";
import { apiIntermittentSummary } from "../../../api/apiIntermittentCommunications";
import { INTERMITTENT_REFRESH_EVENT } from "../../view/ViewIntermittentCommunications";
import { UIText } from "../../ui/Text";

const REFRESH_MS = 5 * 60 * 1000;

interface Props extends MenuItemProps {
  title: string;
}

/**
 * Voce del menu laterale "Comunicazioni Intermittenti" (solo ROOT e AMMINISTRATORI),
 * con il numero di comunicazioni che richiedono un intervento.
 */
export const IntermittentMenuItem = (props: Props): JSX.Element => {
  const history = useHistory();
  const loggedUser = useSelector(selectorLoggedUser);
  const hasPermission = usePermissionForRoute(Routes.intermittentCommunications);
  const enabled = hasPermission && isAdminOrRoot(loggedUser);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) return;

    const load = (): void => {
      apiIntermittentSummary()
        .then(s => setCount(s.needs_action))
        .catch(() => undefined);
    };

    load();
    const timer = window.setInterval(load, REFRESH_MS);
    window.addEventListener(INTERMITTENT_REFRESH_EVENT, load);

    return (): void => {
      window.clearInterval(timer);
      window.removeEventListener(INTERMITTENT_REFRESH_EVENT, load);
    };
  }, [enabled]);

  if (!enabled) return <></>;

  return (
    <StyledMenuItem
      {...props}
      onClick={(): void => history.push(Routes.intermittentCommunications)}
      data-cy="menu-intermittent-communications"
    >
      <UIText>{props.title}</UIText>
      {count > 0 && <Badge count={count} size="small" style={{ marginLeft: 8 }} title="Da gestire" />}
    </StyledMenuItem>
  );
};

const StyledMenuItem = styled(Menu.Item)`
  cursor: pointer;
  color: ${process.env.REACT_APP_THEME_COLOR};
`;
